module.exports = [{
      plugin: require('/Users/marccabezas/Desktop/Projects/choosify-landing/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
